export default () => ({
    customers:[],
    customer:null,
    addedCustomer:null,
    addedDocument:null,
    addedDocuments:[],
    customers_view:[]
});
